export default __webpack_public_path__ + "static/media/aboutUsPic1.ab50d79b.jpg";